import { useQuery } from "@tanstack/react-query";
import ApiClient from "./ApiClient";
import UserInfo from "../interface/UserInfo";

async function get(): Promise<UserInfo[]> {
    const response = await ApiClient({ url: "users", method: "GET" });

    if (response.status === 200) {
        return response.data;
    }
    throw new Error(response.data);
}

export function useGetUsersQuery() {
    return useQuery<UserInfo[]>({
        queryKey: ["get-users"],
        queryFn: get,
        refetchOnWindowFocus: false,
    });
}